import { render, staticRenderFns } from "./ContactsForm.vue?vue&type=template&id=574336f5&scoped=true&"
import script from "./ContactsForm.vue?vue&type=script&lang=js&"
export * from "./ContactsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactsForm.vue?vue&type=style&index=0&id=574336f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574336f5",
  null
  
)

component.options.__file = "ContactsForm.vue"
export default component.exports